import React from "react";
import { useTranslation} from 'react-i18next';
import { Badge } from "react-bootstrap";
import { ServiceElement } from "./service_element";

export const Services = (props) => {
  const { t } = useTranslation(); 
  const services = [];

  for (var i=0; i < t("Services.count"); i++) {
    services.push({
      "img": t("Services.service_"+i+".img"),
      "name": t("Services.service_"+i+".name"),
      "text": t("Services.service_"+i+".text"),
    });
  }  

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{t("Services.title")}</h2>
          <p>
            {t("Services.pitch")}
          </p>
        </div>
        <div className="row">
          {services.length > 0
            ? services.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-lg-4">
                  <center>
                    <ServiceElement
                      serviceImg={d.img}
                      serviceName={d.name}
                      serviceText={d.text}
                    >
                      { i===5 ?
                        <Badge 
                          className="badge-overlay"
                        >
                            Coming Soon
                        </Badge>   
                      : null
                      }  
                    </ServiceElement> 
                  </center>                   
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

//{services.length > 0
//  ? services.map((d, i) => (
//      <div key={`${d.name}-${i}`} className="col-md-4">
//        {" "}                                
//        <img src={d.img} alt="" className="service-img" />{" "}
//        { i===5 ?
//        <Badge 
//          className="badge-overlay"
//        >
//            Coming Soon
//        </Badge>   
//        : null
//        }                      
//        <div className="service-desc">
//          <h3>{d.name}</h3>
//          <p>{d.text}</p>
//        </div>
//      </div>
//    ))
//  : "loading"}